import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL presentationS
export const presentationList = (params = '') => Http.get(`/document-company-presentations${serialize(params)}`)
export const presentationCreate = (params = '') => Http.post('/document-company-presentations', params)
export const presentationByID = (params = '') => Http.get(`/document-company-presentations/${params}`)
export const presentationUpdate = (params = '') => Http.put(`/document-company-presentations/${params.id}`, params)
export const presentationDestroy = (params = '') => Http.delete(`/document-company-presentations/${params.id}`)
